/**
 * Copyright (c) 2021-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

import { Feide, HeartLine } from "@ndla/icons";
import { Button, DialogRoot, DialogTrigger } from "@ndla/primitives";
import { SafeLinkButton } from "@ndla/safelink";
import { css } from "@ndla/styled-system/css";
import { styled } from "@ndla/styled-system/jsx";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { routes } from "../../routeHelpers";
import { AuthContext } from "../AuthenticationContext";
import { LoginModalContent } from "../MyNdla/LoginModalContent";

const buttonCss = css.raw({
  tabletDown: {
    paddingInline: "xsmall",
  },
});

const FeideLoginLabel = styled("span", {
  base: {
    tabletDown: {
      display: "none",
    },
  },
});

export const FeideLoginButton = () => {
  const { t } = useTranslation();
  const { user, authenticated } = useContext(AuthContext);

  if (authenticated && user) {
    return (
      <SafeLinkButton variant="tertiary" css={buttonCss} to={routes.myNdla.root} aria-label={t("myNdla.myNDLA")}>
        <HeartLine />
        <FeideLoginLabel>{t("myNdla.myNDLA")}</FeideLoginLabel>
      </SafeLinkButton>
    );
  }

  return (
    <DialogRoot>
      <DialogTrigger asChild>
        <Button variant="tertiary" css={buttonCss} aria-label={t("user.buttonLogIn")} title={t("user.buttonLogIn")}>
          <Feide />
          <FeideLoginLabel>{t("login")}</FeideLoginLabel>
        </Button>
      </DialogTrigger>
      <LoginModalContent masthead />
    </DialogRoot>
  );
};
